import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { RequestsEvaluatedComponent } from './requests-evaluated/requests-evaluated.component';
import { ViewRequestsComponent } from './view-requests/view-requests.component';
import { RequestsStudentComponent } from './requests-student/requests-student.component';
import { ViewTestComponent } from './view-test/view-test.component';
import { ContentStateRequestsComponent } from './content-state-requests/content-state-requests.component';
import { RequestsRecognitionComponent } from './requests-recognition/requests-recognition.component';

const routes: Routes = [
  { path: 'solicitudes-evaluadas', component: RequestsEvaluatedComponent }, // cambiar las url por notación solicitudes-evaluadas
  { path: 'ver-solicitudes', component: RequestsStudentComponent }, // cambiar las url por notación ver-solicitudes
  { path: 'ver-solicitudes/pruebas', component: ViewTestComponent},
  { path: 'ver-solicitudes/asistencial', component: ContentStateRequestsComponent},
  { path: 'ver-solicitudes/reconocimiento', component: RequestsRecognitionComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule {}
